import { supabase } from "@/integrations/supabase/client";

const REVIEW_EMAIL = "review@buxbox.app";

export function isReviewAccount(email: string): boolean {
  return email?.toLowerCase().trim() === REVIEW_EMAIL;
}

/**
 * Authenticate the Apple review account via edge function.
 * Returns the session or throws.
 */
export async function loginReviewAccount(code: string) {
  const { data, error } = await supabase.functions.invoke("review-login", {
    body: { email: REVIEW_EMAIL, code },
  });

  if (error) throw new Error(error.message || "Review login failed");
  if (data?.error) throw new Error(data.error);
  if (!data?.session) throw new Error("No session returned");

  // Set the session in the client
  const { error: setError } = await supabase.auth.setSession({
    access_token: data.session.access_token,
    refresh_token: data.session.refresh_token,
  });

  if (setError) throw setError;

  return data.session;
}
